"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizedStringEditorComp = void 0;
const react_1 = __importStar(require("react"));
const defaultLanguages = [
    { id: "en", name: "English" },
    { id: "fr", name: "Français" },
    { id: "es", name: "Español" },
    { id: "pt", name: "Português" },
    { id: "sw", name: "Kiswahili" },
    { id: "tet", name: "Tetum" },
    { id: "id", name: "Bahasa Indonesia" },
    { id: "ht", name: "Créole Haïtien" },
    { id: "my", name: "Burmese" },
    { id: "km", name: "Khmer" },
    { id: "am", name: "Amharic" },
    { id: "hi", name: "Hindi" },
    { id: "bn", name: "Bangla" },
    { id: "rw", name: "Kinyarwanda" },
    { id: "ne", name: "Nepali" },
    { id: "sd", name: "Sindhi" },
    { id: "ur", name: "Urdu" },
    { id: "so", name: "Somali" },
    { id: "de", name: "German" },
    { id: "it", name: "Italian" },
    { id: "ja", name: "Japanese" },
    { id: "ar", name: "Arabic" },
    { id: "vi", name: "Vietnamese" },
    { id: "mg", name: "Malagasy" }
];
const LocalizedStringEditorComp = (props) => {
    const { value, onChange, availableLanguages, readonly, multiline, placeholder } = props;
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const languageCount = value ? Object.keys(value).filter(key => key !== '_base').length : 0;
    const handleChangeValue = (languageCode, newValue) => {
        if (readonly)
            return;
        const updatedValue = { ...(value || {}), _base: "en", [languageCode]: newValue };
        onChange(updatedValue);
    };
    const addLanguage = (languageCode) => {
        const updatedValue = { ...(value || {}), _base: "en", [languageCode]: "" };
        onChange(updatedValue);
    };
    const removeLanguage = (languageCode) => {
        if (confirm(T `Are you sure you want to remove the ${languageCode} translation?`)) {
            const updatedValue = { ...value };
            delete updatedValue[languageCode];
            onChange(updatedValue);
        }
    };
    const renderClosedState = () => {
        const displayedValue = value?.[value._base || "en"] || "";
        return (react_1.default.createElement("div", { className: "input-group" },
            react_1.default.createElement("input", { type: "text", className: "form-control", value: displayedValue, onChange: (e) => handleChangeValue(value?._base || "en", e.target.value), placeholder: placeholder }),
            react_1.default.createElement("button", { className: "btn btn-secondary", onClick: () => setIsOpen(true), disabled: !displayedValue },
                react_1.default.createElement("i", { className: "fas fa-globe" }),
                " ",
                languageCount > 1 ? languageCount : "")));
    };
    const renderOpenState = () => (react_1.default.createElement("div", null,
        Object.entries(value || {}).map(([langCode, text]) => (langCode !== '_base' && (react_1.default.createElement("div", { key: langCode, className: "mb-2" },
            react_1.default.createElement("div", { className: "input-group" },
                react_1.default.createElement("span", { className: "input-group-text", style: { width: "40px" } }, langCode),
                multiline ? (react_1.default.createElement("textarea", { className: "form-control", value: text || "", onChange: (e) => handleChangeValue(langCode, e.target.value), rows: 3 })) : (react_1.default.createElement("input", { type: "text", className: "form-control", value: text || "", onChange: (e) => handleChangeValue(langCode, e.target.value) })),
                langCode !== value?._base && (react_1.default.createElement("button", { className: "btn btn-outline-secondary", onClick: () => removeLanguage(langCode), title: T `Remove language` },
                    react_1.default.createElement("i", { className: "fas fa-times" })))))))),
        react_1.default.createElement("div", { className: "mt-2" },
            react_1.default.createElement("button", { className: "btn btn-link btn-sm dropdown-toggle", type: "button", "data-bs-toggle": "dropdown" }, T `Add Language`),
            react_1.default.createElement("ul", { className: "dropdown-menu" }, (availableLanguages || defaultLanguages)
                .filter((lang) => !value || !value[lang.id])
                .map((lang) => (react_1.default.createElement("li", { key: lang.id },
                react_1.default.createElement("a", { className: "dropdown-item", onClick: () => addLanguage(lang.id) }, lang.name))))),
            react_1.default.createElement("button", { className: "btn btn-link btn-sm", onClick: () => setIsOpen(false) }, T `Close`))));
    return isOpen ? renderOpenState() : renderClosedState();
};
exports.LocalizedStringEditorComp = LocalizedStringEditorComp;
exports.default = exports.LocalizedStringEditorComp;
